'use client';

import { createContext, useContext } from 'react';
import type { MiniCartIslandConfig } from '../useMiniCartIslandConfig';

const CommerceCartRootContext = createContext<MiniCartIslandConfig | undefined>(
  undefined
);

export const CommerceCartRootProvider = CommerceCartRootContext.Provider;

/** The layout's one commerce-core provider's config; `undefined` outside it. */
export const useCommerceCartRoot = (): MiniCartIslandConfig | undefined =>
  useContext(CommerceCartRootContext);
